import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPopupComponent } from '@app/shared/map-popup/map-popup.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAejgj1DfWqkbpPjnayAK3z-TwX6aERGMc',
      libraries: ['places']
    }),
  ],
  declarations: [
    MapPopupComponent
  ],
  exports: [
    MapPopupComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
]
})

export class MapPopupModule { }



// WEBPACK FOOTER //
// ./src/app/shared/map-popup/map.popup.module.ts